<div
  class="file-upload-container"
  [ngClass]="{ 'add-margin': hasMargin }"
  (onFileDropped)="onFileDrop($event)"
  appDragDrop>
  <span class="fake-btn" [hidden]="file">Choose file</span>
  <span class="file-text">{{
    file ? file.name : 'or drag and drop file here'
  }}</span>
  <!-- <i
    class="material-icons delete-file"
    [hidden]="!file"
    [ngClass]="{ progress: progress }"
    (click)="clearValue($event)">
    delete_forever
  </i> -->
  <input class="file-input" type="file" [accept]="accept" />
  <div class="loader-container" *ngIf="progress">
    <mat-spinner diameter="50" class="margin-auto"></mat-spinner>
  </div>
</div>
